<template>
  <fragment>
    <b-form @submit.prevent="getReportData">
      <b-form-row>
        <b-col cols="12">
          <b-form-group label="Cutoff Date:">
            <datepicker
              v-model="cutoffDate"
              :formatter="dateFormatter"
              input-class="form-control bg-white"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button
            variant="v2_primary"
            type="submit"
            :disabled="reportLoading"
          >
            Generate
          </b-button>
        </b-col>
      </b-form-row>
    </b-form>
    <b-row>
      <b-col cols="12">
        <half-circle-spinner v-if="reportLoading" />
        <society-kpi-report v-else-if="reportData" :kpi-data="reportData" />
      </b-col>
    </b-row>
  </fragment>
</template>

<script>
import SocietyKpiReport from '@/components/society/kpi-report/SocietyKpiReport';
import Datepicker from 'vuejs-datepicker';
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { HalfCircleSpinner } from 'epic-spinners';

export default {
  name: 'KpiReportModalContent',
  components: {
    Datepicker,
    SocietyKpiReport,
    HalfCircleSpinner,
  },
  props: {
    society: Object,
  },
  data: function () {
    return {
      reportData: null,
      cutoffDate: null,
      reportLoading: false,
    };
  },
  methods: {
    dateFormatter: function (date) {
      return this.$dayjs(date).format('MM/DD/YYYY');
    },
    getReportData: async function () {
      this.reportLoading = true;
      try {
        this.reportData = await Api.getSocietyKpiReportData(
          this.society.id,
          this.$dayjs(this.cutoffDate).format('MM/DD/YYYY')
        );
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.reportLoading = false;
      }
    },
  },
};
</script>

<style scoped></style>
